<script setup>
  import {
    couponRef,
  } from "@/firebase/firebase";
  import { query, where } from "firebase/firestore";
  import { useCollection } from "vuefire";

  const coupons = useCollection(
    query(
      couponRef,
      where("used", "==", true),
    ),
    { ssrKey: "coupon" }
  );

</script>

<template>
  <div v-if="coupons.length">
    <v-card class="mx-auto mt-9 mb-9 pa-md-4 ms-2 me-2" min-height="60" v-for="(coupon, i) in coupons" :key="i">

      <v-row align="center ma-2" class="pl-5">
        <v-col cols="12">
          <div class="text-no-wrap secondary" style="width: 8rem;">
            コード：{{ coupon.coupon_code }} <br>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>

  <div v-else class="mx-auto mt-9 ml-9">
    <span>現在使用済みのクーポンはありません </span>
  </div>
</template>
